export default __webpack_public_path__ + "static/media/Schnecke-mit-Blume.86d04dd0.webp";